export const VOTE_POLL_REQUESTED = "VOTE_POLL_REQUESTED";
export const VOTE_POLL_FULFILLED = "VOTE_POLL_FULFILLED";
export const VOTE_POLL_REJECTED = "VOTE_POLL_REJECTED";
